//Post
export const API_MASTER = "master/";
export const API_PATIENTS = "master/patient/";
export const API_HIDE_PATIENTS = "master/patient/hide";
export const API_PATIENTS_EXPORT = "master/patient/export-csv";
export const API_PATIENTS_EXPORT_ALL = "master/patient/export-csv-all";
export const API_ADMIN_EXPORT_ALL_DATA_URINE = "record/records/export-all-data-csv";
export const API_ANALYTICS_DIAPER_RESIZE =
  "master/patients/analytics-diaper-resize";

export const API_POST_LOGIN = "auth/signin";

export const API_DIAPERS = "master/diapers/";
export const API_FACILITY = "account/facilities/";

export const API_FACILITY_LINK_REQUEST =
  "master/accounts/facility-link-requests";

export const API_MASTER_AREAS = "master/areas";

// Cảnh báo hạn chứng chỉ TLS của các tên miền hệ thống đang dùng.
export const API_TLS_CERTIFICATES = "master/certificates/";
export const API_TLS_CERTIFICATE_ALERTS = "master/certificates/alerts";
export const API_MASTER_DEG = "master/deg/";
export const API_MASTER_STAFFS = "master/staffs/";
export const API_MASTER_GROUPS = "master/groups/";

export const API_AUTH_SIGNIN = "master/auth/signin";
export const API_AUTH_SIGNOUT = "master/auth/signout";
export const API_AUTH_UPDATE_SESSION = "master/auth/update-sesssion";
export const API_AUTH_SEND_OTP = "auth/send-otp";

export const API_MASTER_ACCOUNT = "master/account/";
export const API_MASTER_ACCOUNT_SEND_LINK_RESET_PASSWORD =
  "master/account/send-code-reset-password";
export const API_ACCOUNT = "account/";
export const API_ACCOUNT_USERS = "account/users";
export const API_ACCOUNT_USERS_CHANGE_PHONE = "account/users/change-phone";
export const API_ACCOUNT_USERS_JOIN_FACILITY = "account/users/join-facility/";
export const API_ACCOUNT_FACILITTIES = "account/facilities/";
export const API_ACCOUNT_FACILITTIES_SHARE_CODE =
  "account/facilities/share-code";
export const API_ACCOUNT_FACILITTIES_JOIN_REQUEST =
  "account/facilities/join-request";
export const API_ACCOUNT_FACILITTIES_APPRROVAL_REQUEST =
  "account/facilities/approval-request";
export const API_ACCOUNT_SETTING = "account/setting";
export const API_ACCOUNT_VALIDATE = "account/validate";
export const API_ACCOUNT_RESET_PASSWORD = "master/account/reset-password";
export const API_ACCOUNT_VALIDATE_PASSWORD = "account/validate-password";
export const API_ACCOUNT_CHANGE_PASSWORD = "master/account/change-password";
export const API_ACCOUNT_BILLS = "account/bills/";
export const API_ACCOUNT_BILLS_EXPORT = "account/bills/export";

export const API_GET_DEVICES = "devices/";
export const API_GET_DEVICES_PAIR = "devices/pair";
export const API_DELETE_SENSOR = "devices/";

export const API_ANALYTIC_URINE = "records/patient/";
export const API_ANALYTIC_URINE_EXTERNAL = "records/external/patient/";
export const API_ANALYTIC_DIAPER_RESIZE = "master/patients/";
export const API_ANALYTIC_DIAPER_INFO = "master/patients/";

export const API_GET_USER_INFO = "master/account/";
export const API_GET_LIST_NOTICES = "master/notices/";

export const API_GET_CLINIC = "master/account/clinics/";
export const API_UPDATE_CLINIC = "master/account/clinics/";

export const API_RECORD_CHART = "record/records/patient/:id/chart-temp"
export const API_RECORD_SORTED = "record/records/patient/:id/record_sorted"

export const API_GET_ALL_DEVICES = "record/devices/find-device-by-mac";
export const API_DELETE_DEVICE = "record/devices/delete-by-mac";

export const API_RECORD_SORTED_PUBLIC = "record/records/external/patient/:id/record_sorted"